import { getWidth } from "../common";

const columns = 15;
export default Array.from({ length: columns }, (_, current) => {
  const field = `switch_tactile_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true,
  };
});
